<template>
  <div id="SectionCertifications">
    <UIContainer>
      <div class="SectionCertifications__container">
        <div class="SectionCertifications__left">
          <h2 class="SectionCertifications__title">
            A certified platform for audit-ready compliance
          </h2>

          <div class="SectionCertifications__logos">
            <img
              class="SectionCertifications__logo"
              src="./images/certifications/bcorp.avif"
              alt="B Corporation Certified logo - Sustainalyse verified B Corp"
              height="100"
              loading="lazy"
            />
            <img
              class="SectionCertifications__logo"
              src="./images/certifications/efrag.avif"
              alt="EFRAG Friends of Sustainability Reporting badge"
              height="60"
              loading="lazy"
            />
            <img
              class="SectionCertifications__logo"
              src="./images/certifications/ecovadis.avif"
              alt="EcoVadis Platinum rating certification badge"
              height="46"
              loading="lazy"
            />
            <img
              class="SectionCertifications__logo"
              src="./images/certifications/ghg.avif"
              alt="GHG Protocol aligned carbon accounting methodology"
              height="52"
              loading="lazy"
            />
          </div>
        </div>

        <ul class="SectionCertifications__list">
          <li
            v-for="certification in certifications"
            :key="certification.icon"
            class="SectionCertifications__list-item"
          >
            <UIIcon :name="certification.icon" />
            <span>{{ certification.title }}</span>
          </li>
        </ul>
      </div>
    </UIContainer>
  </div>
</template>

<script setup lang="ts">
import UIContainer from '@/views/components/ui/containers/UIContainer/UIContainer.vue'
import UIIcon from '@/views/components/ui/icons/UIIcon.vue'

const certifications = [
  {
    icon: 'cert1',
    title: 'Built on GHG Protocol & ISO 14064',
  },
  {
    icon: 'cert2',
    title: 'Friends of EFRAG Sustainability Reporting',
  },
  {
    icon: 'cert3',
    title: 'B Corp Certified',
  },
]
</script>

<style lang="scss" scoped>
#SectionCertifications {
  .SectionCertifications__container {
    background-color: $color-lp-bg-brand-section;
    border-radius: 1rem;
    padding: 1rem 2rem;
    margin: 0 auto;
    display: grid;
    gap: 2rem;
    grid-template-columns: 1fr;

    @include lg {
      grid-template-columns: 726px 1fr;
      padding: 2rem 4rem;
    }
  }

  .SectionCertifications__left {
    display: flex;
    flex-direction: column;
  }

  .SectionCertifications__title {
    font-size: 24px;
    line-height: 32px;
    font-weight: 600;
    color: $color-white;
    letter-spacing: -2%;

    @include md {
      font-size: 36px;
      line-height: 44px;
    }
  }

  .SectionCertifications__logos {
    display: flex;
    gap: 1.5rem;
    margin-top: 2rem;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;

    @include md {
      justify-content: flex-start;
      margin-top: 5rem;
    }
  }

  .SectionCertifications__logo {
    object-fit: contain;
  }

  .SectionCertifications__list {
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
    margin: auto 0;
  }

  .SectionCertifications__list-item {
    @include font-size-16px();
    display: flex;
    align-items: center;
    gap: 0.625rem;
    color: $color-white;
    font-weight: 500;
    background-color: $color-ui-accent-main;
    padding: 1rem 1.25rem;
    border-radius: 12px;
    letter-spacing: 0%;
  }
}
</style>
